import type { FaireProductEntity } from "../../entity_types/product";

export const p_u8bggjh4b8: FaireProductEntity = {
  token: "p_u8bggjh4b8",
  type: "product",
  name: "Puka Shell Round Necklace 12 Pcs .",
  brandName: "Puka Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/c946c461789a832d8b6779182a7afb14635615a4d99ddc9188be628335c39448.webp",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6221e995e17ada15d9580ea170302fae9ab5f2c9ae162d214bde05eddbb9a79b.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
